<template>
    <div class="specialistFilter-box no-swiping">
        <div class="specialistFilter--select">
            <SelectButton v-model="field.value.sf_select" :options="selectOptions" name="sf_select" id="SF-select" />
        </div>
        
        <template v-if="field.value.sf_select == 'Postleitzahl'">

            <div class="specialistFilter--plz">
                <div class="specialistFilter--plz--input">
                    <strong class="label">Bitte Plz angeben.</strong>
                    <InputText
                        v-model="postcodeValue"
                        inputmode="numeric"
                        pattern="[0-9]{5}"
                        maxlength="5"
                        name="sf_plzInputValue" 
                        id="sf_plzInputValue"
                    />
                    <!-- <Message v-if="checkErrors.field == 'sf_plzInputValue'" severity="error" size="small" variant="simple">{{checkErrors.fieldmessage}}</Message> -->
                </div>
                <div class="specialistFilter--plz--range no-swiping">
                    <strong class="label">Reichweite:</strong>
                    <InputText
                        v-model.number="field.value.sf_plzRangeValue"
                        name="sf_plzRangeValue"
                    />
                    <Slider v-model="field.value.sf_plzRangeValue" name="sf_plzRangeValue" id="sf_plzRangeValue"/>
                    <!-- <Message v-if="checkErrors.field == 'sf_plzRangeValue'" severity="error" size="small" variant="simple">{{checkErrors.fieldmessage}}</Message> -->
                </div>
            </div>
        </template>
        <template v-else>
            <div class="specialistFilter--company">
                <strong class="label">Firmennamen:</strong>
                <InputText
                    v-model="field.value.sf_companyValue"
                    name="sf_companyValue"
                    id="sf_companyValue"
                />
                <!-- <Message v-if="checkErrors.field == 'sf_companyValue'" severity="error" size="small" variant="simple">{{checkErrors.fieldmessage}}</Message> -->
            </div>
        </template>
        <!-- {{ field }} -->
        <!-- <Message v-if="field.invalid" severity="error" size="small" variant="simple">{{field.errors}}</Message> -->
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    data: Object,
    field: Object,
    fields: Object,
    step: Object,
});

// const selectValue = ref('Postleitzahl');
const selectOptions = ref(['Postleitzahl', 'Firmenname']);

const postcodeValue = computed({
    get() {
        return props.field.value.sf_plzInputValue ?? '';
    },
    set(value) {
        props.field.value.sf_plzInputValue = normalizePostcode(value);
    }
});

function normalizePostcode(value) {
    return String(value ?? '').replace(/\D/g, '').slice(0, 5);
}

// const checkErrors = computed(() => {
//     if(props.fields.errors.length <= 0) return {field: false};
//     return props.field.errors[0];
// });

</script>

<style lang="scss">

.p-togglebutton {
    &[data-p="checked"] {
        pointer-events: none !important;
    }
}

</style>